import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const LoginRegisterButtons = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-row align-items-center">
      <Button onClick={() => navigate("/login")}>Login</Button>
      <span className="text-white mx-2">|</span>
      <Button onClick={() => navigate("/register")}>Register</Button>
    </div>
  );
};

export default LoginRegisterButtons;
